import request from '../../request';
import { BLOB_RESPONSE_TYPE } from '../../../constants/reading/ApiConstants';

class ApiGatewayAuthorizerClient {
    static getActivityPdf = async activityUrl => {
        const activityPdfFile = await request.get(activityUrl, {
            responseType: BLOB_RESPONSE_TYPE,
        });

        return URL.createObjectURL(activityPdfFile);
    };
}

export default ApiGatewayAuthorizerClient;
